import {
  ITennisResults,
  TennisResults,
} from "@sky-it-livedata/livedata-sports-design-system";

import { log } from "../../utils/log";
import { transformQuery } from "./transformers/transformQuery";
import { ResultsData } from "./types";
import { useSubscription } from "../../hooks/useSubscription";
import { ResultsSubscriptionData } from "./types";
import { transformSubscription } from "./transformers/transformSubscription";
import { graphql } from "appsync";
import { WidgetContext } from "../../types/WidgetContext";
import { setDigitalData } from "../../utils/analyticsClient";

export const setCustomAttributes = ({props, variables}: WidgetContext<ResultsData>) => {
  const {categoryName, date} = props.data.getSdapiResultsWidget;
  return {
    category: categoryName,
    date: date && date.split('T')[0],
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql(
  "subscription onUpdateSdapiResultsWidgetByDay($day: ID!, $seasonId: ID!, $competitionId: ID!) {\n  onUpdateSdapiResultsWidgetByDay(\n    day: $day\n    seasonId: $seasonId\n    competitionId: $competitionId\n  ) {\n    seasonId\n    competitionId\n    day\n    categoryName\n    date\n    matches {\n      status\n      startDate\n      roundName\n      resultType\n      firstPosition {\n        isServing\n        players {\n          nationality\n          name\n          seed\n        }\n        score {\n          set\n          tie\n          isWinner\n        }\n        isWinner\n      }\n      secondPosition {\n        isServing\n        players {\n          nationality\n          name\n          seed\n        }\n        score {\n          set\n          tie\n          isWinner\n        }\n        isWinner\n      }\n    }\n  }\n}"
);

export function getServerProps({
  props,
}: WidgetContext<ResultsData>): ITennisResults {
  return transformQuery(props);
}

export default function Results({
  props,
  variables,
  ...rest
}: WidgetContext<ITennisResults>) {
  log({ props, variables, ...rest });

  setDigitalData([{targetKey: "pagetemplate", value: "sportsdata"}]);

  const updatedProps = useSubscription<
    ITennisResults,
    ResultsSubscriptionData,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables: {
      day: variables.day,
      seasonId: variables.seasonId,
      competitionId: variables.competitionId,
    },
    enabled: Boolean((props.date!).split('T')[0] === new Date().toISOString().split('T')[0]),
    transform: transformSubscription,
    mergeData: false,
  }) as ITennisResults;
  
  return <TennisResults {...updatedProps}/>;
}
